import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

const MobileSection = () => {
    const [activeBars, setActiveBars] = useState([0, 3, 6, 9]); // ✅ multiple default green bars

    const toggleBar = (index) => {
      setActiveBars((prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index) // remove if already active
          : [...prev, index] // add if not active
      );
    };

  const mobileData = [
    {
      title: "Records",
      imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744549111/image_audxlt.png",
      description: "Farmers update records on the go and presented in easy to read dashboards for planning & Managemnt",
    },
    {
      title: "Service Providers",
      imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744549110/image-1_gyesvt.png",

     description: "Farmer supported by verified service providers eg Agricultural extension workers to improve their<br />productivity.",

    },
    {
      title: "Contracts",
      imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744549110/image-2_itgncb.png",

      description: "Farmers get market assurance for their produce. Offtake partners <br /> secure raw materials for production.",
    },
    {
      title: "Resources",
      imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744548927/image_aowgl4.png",
      description: "Farmer mobilize resources for production",
    },
    {
      title: "Market",
      imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744548927/image-2_sg5whu.png",
      description: "Farmers Access market ",
    },
    {
      title: "Community",
      imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744548927/image-1_dd00vd.png",

      description: "App use4rs rated and reviewed at the end of servcie",
    },
   
  ];


  return (
    <div className="relative px-4 md:px-20  bg-white md:-mt-4 md:pt-6">
      <div className="w-full rounded-md">
        <Swiper
          slidesPerView={3}
          slidesPerGroup={3}
          spaceBetween={30}
          loop={true}
          modules={[Autoplay]}
            autoplay={{
                      delay: 2000,
                      disableOnInteraction: false,
                    }}
                   
          breakpoints={{
            320: { slidesPerView: 3, slidesPerGroup: 1, spaceBetween: 10 },
            640: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 10 },
            1024: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 20 },
          }}
        >
          {mobileData.map((mobile, index) => (
            <SwiperSlide key={index} className="mx-auto flex flex-col justify-center items-center">
              {/* Bar (clickable) */}
              <div
                onClick={() => toggleBar(index)}
                className={`cursor-pointer md:h-[5px] h-[2px] md:w-full md:mb-2 rounded-full transition-all duration-300 ${
                  activeBars.includes(index) ? "bg-[#155528]" : "bg-gray-400"
                }`}
              ></div>

              {/* Content */}
              <div className="flex w-full md:mt-4">
                <div className="flex flex-col justify-center text-black w-[160%] ">
                  <p className="md:text-[22px]  text-[8px] font-extrabold md:mt-0 mt-2">{mobile.title}</p>
                  <p
  className="md:text-[17px] text-[6px] font-medium md:mt-2"
  dangerouslySetInnerHTML={{ __html: mobile.description }}
 style={{lineHeight:"1.10"}}></p>

                </div>
                <div className="flex justify-center items-center w-1/2">
                  <img
                    src={mobile.imageUrl}
                    alt={mobile.title}
                    className="md:w-[50px] md:h-[80px] h-[35px] w-[30px] object-contain"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default MobileSection;
